import { seo } from '../seo';
export { DomainRegistrationAgreementPage as default } from '../../src/pages/Legal/DRA';
export const meta = () => seo('legal.dra');
